//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import productQuery from '~/apollo/queries/product/product-slug'
import productCategoryQuery from '~/apollo/queries/product/category-id-products.gql'

export default {
  mixins: [seo],
  data () {
    return {
      catId: '0',
      fetched: false
    }
  },
  apollo: {
    products: {
      prefetch: true,
      query: productQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      // `data` is undefined when the query errored — guard or the SSR process dies.
      result ({ data, loading, networkStatus }) {
        if (data && data.products && data.products.length > 0) {
          this.seoTitle = data.products[0].name
          this.seoNoindex = !!data.products[0].excludeFromSearchResults
        }
        this.fetched = true
      },
      error (error) {
        console.error('[apollo] ' + this.$route.fullPath + ': ' + (error && error.message))
        this.fetched = true
      }
    },
    productCategory: {
      prefetch: true,
      query: productCategoryQuery,
      variables () {
        return { documentId: this.catId }
      }
      /* showcases only
      ,
      result ({ data }) {
        if (data.productCategory) {
          this.seoCategory = data.productCategory.pageTitle
        }
      }
      */
    }
  },
  created () {
    // Exactly one well-formed ?catId=, else the '0' sentinel (a repeated
    // catId arrives as an array, which Strapi rejects as an invalid ID).
    const raw = this.$route.query.catId
    const catId = Array.isArray(raw) ? raw[0] : raw
    this.catId = (typeof catId === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(catId)) ? catId : '0'
  },
  computed: {
    categoryProducts () {
      return this.productCategory &&
        this.productCategory.products
        ? this.productCategory.products
        : null
    }
  }
}
